import React, { useState, useEffect } from 'react';

const KEY = 'jsdb_theme';

export function useDarkMode() {
  const [dark, setDark] = useState(() => {
    const stored = localStorage.getItem(KEY);
    if (stored) return stored === 'dark';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
    localStorage.setItem(KEY, dark ? 'dark' : 'light');
  }, [dark]);

  return [dark, setDark];
}

export default function DarkModeToggle({ dark, setDark }) {
  return (
    <button
      className={`theme-toggle ${dark ? 'dark' : ''}`}
      onClick={() => setDark(d => !d)}
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={dark ? 'Light mode' : 'Dark mode'}
    >
      <span className="theme-icon">{dark ? '☀️' : '🌙'}</span>
    </button>
  );
}
